<div class="sidebar-backdrop"
  #backdrop
  (click)="onBackdropClick()">
</div>

<button class="sidebar-toggle-btn"
  [class.sidebar-open]="sidebarOpenClass"
  [class.d-none]="!showToggleBtn"
  #toggleBtn
  title="Toggle sidebar"
  aria-label="Toggle sidebar"
  (click)="onToggle()">

  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
    stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
    stroke-linejoin="round" viewBox="0 0 24 24"
    [style.display]="showCloseIcon ? '' : 'none'">
    <polyline points="15 18 9 12 15 6"/>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
    stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
    stroke-linejoin="round" viewBox="0 0 24 24"
    [style.display]="showOpenIcon ? '' : 'none'">
    <polyline points="9 18 15 12 9 6"/>
  </svg>

</button>

<div class="d-flex" style="min-height:100vh;">

  <aside class="sidebar-sticky bg-white" #sidebar>

    <div class="sidebar-mobile-header">
      <span class="sidebar-mobile-title">Menu</span>
      <button class="drawer-close-btn"
        #drawerClose
        aria-label="Close sidebar"
        (click)="onDrawerClose()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none"
          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" viewBox="0 0 24 24">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="sidebar-search-wrap">
      <svg class="sidebar-search-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <input
        class="sidebar-search-input"
        type="text"
        placeholder="Search menu..."
        [(ngModel)]="searchQuery"
      />
    </div>

    <nav class="sidebar-nav">

      <div class="menu-group">
        <button class="menu-group-header" (click)="toggleReleaseGroup()">
          <svg class="menu-folder-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
            fill="currentColor" viewBox="0 0 24 24">
            <path d="M10 4H2v16h20V6H12l-2-2z"/>
          </svg>
          <span class="menu-group-label">Version History</span>
          <span class="menu-group-toggle">
            {{ releaseGroupOpen ? '−' : '+' }}
          </span>
        </button>

        <div class="menu-group-items" [class.open]="releaseGroupOpen">
          @for (data of versionHistoryItems; track data) {
            <a [routerLink]="['/release-notes', data.id]"
               class="menu-item"
               [class.active]="activeId === data.id"
               (click)="onClick(data.id)">
              <svg class="menu-doc-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" viewBox="0 0 24 24">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
              {{ data.version_name }}
            </a>
          }
        </div>
      </div>

      <div class="menu-divider"></div>

      <div class="menu-group">
        <button class="menu-group-header" (click)="toggleArchive()">
          <svg class="menu-folder-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
            fill="currentColor" viewBox="0 0 24 24">
            <path d="M10 4H2v16h20V6H12l-2-2z"/>
          </svg>
          <span class="menu-group-label">Archive</span>
          <span class="menu-group-toggle">
            {{ archiveOpen ? '−' : '+' }}
          </span>
        </button>

        <div class="menu-group-items" [class.open]="archiveOpen">
          @for (data of archiveItems; track data) {
            <a [routerLink]="['/release_notes', data.id]"
               class="menu-item"
               [class.active]="activeId === data.id"
               (click)="onClick(data.id)">
              <svg class="menu-doc-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" viewBox="0 0 24 24">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
              {{ data.version_name }}
            </a>
          }
          @empty {
            <span class="menu-empty-msg">No archived versions</span>
          }
        </div>
      </div>

    </nav>
  </aside>

  <main class="flex-grow-1 min-vw-0 main-content">

    <div class="d-flex align-items-center mb-3">
      <span class="badge badge-stable text-uppercase fw-bold me-3 rounded-1 py-1 px-2">
        Stable Release
      </span>
      <span class="text-secondary" style="font-size:13px;">{{ releaseDate | date: 'MMMM dd, yyyy' }}</span>
    </div>

    <h1 class="release-title fw-bold mb-3" style="letter-spacing:-1.2px; line-height:1.1;">
      {{ versionName }}: {{ releaseTitle }}
    </h1>
    <p class="subtitle-text mb-4" style="font-size:14.5px; line-height:1.6; max-width:580px;">
      {{ summary }}
    </p>

    <div class="video-block mb-5" *ngIf="videoUrl && videoReady">
      <app-video-player
        [value]="videoUrl"
        [videoId]="releaseNoteid">
      </app-video-player>
    </div>

    <!-- RELEASE OVERVIEW / MIND MAP -->
    <div class="mb-5" *ngIf="mindMapSrc">
      <div class="d-flex justify-content-between align-items-baseline mb-3">
        <h2 class="fw-bold mb-0" style="font-size:20px; letter-spacing:-.4px;">Release Overview</h2>
        <span class="fw-semibold" style="font-size:12px; color:#0070f3;">System Mind Map</span>
      </div>

      <div class="card border rounded-3 shadow-none mindmap-card">
        <div class="card-body p-3 p-sm-4">
          <div class="mindmap-wrapper">
            <img
              [src]="mindMapSrc"
              alt="Architecture Mind Map"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- MODULE SECTION -->
    <div class="index-section mb-5" *ngIf="indexItemsLeft.length > 0 || indexItemsRight.length > 0">
      <div class="d-flex justify-content-between align-items-baseline mb-3">
        <h2 class="fw-bold mb-0 section-title">Module Overview</h2>
        <span class="section-link">Module</span>
      </div>

      <div class="index-card">

        <!-- Left column -->
        <div class="index-table-col">
          <table class="index-table">
            <thead>
              <tr>
                <th class="idx-col-module">Module</th>
                <th class="idx-col-slide">Slide No</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let entry of indexItemsLeft">
                <td class="idx-module-cell">{{ entry.module }}</td>
                <td class="idx-slide-cell idx-slide-clickable"
    (click)="openIndexModal(entry, $event)">
  <!-- {{ entry.slide }} --> View
  <svg *ngIf="entry._imageDocIds?.length"
                       class="idx-slide-icon"
                       xmlns="http://www.w3.org/2000/svg" width="11" height="11"
                       fill="none" stroke="currentColor" stroke-width="2"
                       stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Vertical divider -->
        <div class="index-divider"></div>

        <!-- Right column -->
        <div class="index-table-col">
          <table class="index-table">
            <thead>
              <tr>
                <th class="idx-col-module">Module</th>
                <th class="idx-col-slide">Slide No</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let entry of indexItemsRight">
                <td class="idx-module-cell">{{ entry.module }}</td>
                <td class="idx-slide-cell idx-slide-clickable"
    (click)="openIndexModal(entry, $event)">
  <!-- {{ entry.slide }} --> View
  <svg *ngIf="entry._imageDocIds?.length"
                       class="idx-slide-icon"
                       xmlns="http://www.w3.org/2000/svg" width="11" height="11"
                       fill="none" stroke="currentColor" stroke-width="2"
                       stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
    <!-- END INDEX SECTION -->

    <!-- RELEASE DOCUMENT / PDF -->
    <div class="pdf-section" *ngIf="pdfFilePath">
      <div class="d-flex justify-content-between align-items-baseline mb-3">
        <h2 class="fw-bold mb-0 section-title">Release Document</h2>
        <span class="section-link">PDF Viewer</span>
      </div>

      <div class="pdf-preview-card" (click)="openPdfModal()">
        <div class="pdf-preview-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"
            stroke="#0070f3" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" viewBox="0 0 24 24">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
        </div>
        <div class="pdf-preview-info">
          <span class="pdf-preview-label">Release Document</span>
          <span class="pdf-preview-sub">Click to open the full release PDF in viewer</span>
        </div>
        <span class="pdf-preview-cta">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" viewBox="0 0 24 24">
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          Open
        </span>
      </div>
    </div>

    <!-- HIGHLIGHTS -->
    <div class="highlights-section mt-5" *ngIf="highlightItems.length > 0">

      <div class="highlights-header-bar">
        <div class="highlights-header-left">
          <h2 class="fw-bold mb-0 section-title">Highlights</h2>
        </div>
        <span class="section-link">Release Changes</span>
      </div>

      <div class="highlights-summary-row">
        <div class="hl-summary-badge" *ngFor="let s of highlightSummary">
          <span class="hl-summary-dot" [ngClass]="s.dotClass"></span>
          <span class="hl-summary-count">{{ s.count }}</span>
          <span class="hl-summary-label">{{ s.label }}</span>
        </div>
      </div>

      <div class="highlights-table-wrap">
        <table class="highlights-table">
          <thead>
            <tr>
              <th class="col-sno">S.No.</th>
              <th class="col-opid">OP ID</th>
              <th class="col-change">Change</th>
              <th class="col-module">Module</th>
              <th class="col-subject">Subject</th>
              <th class="col-helpdesk">Helpdesk ID</th>
              <th class="col-action"></th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr class="highlight-row"
                *ngFor="let item of highlightItems; let i = index"
                (click)="openHighlightModal(item, $event)">
              <td class="col-sno text-center">{{ i + 1 }}.</td>
              <td class="col-opid">{{ item.opid }}</td>
              <td class="col-change">
                <span class="change-badge" [ngClass]="getChangeBadgeClass(item.changes)">
                  {{ item.changes }}
                </span>
              </td>
              <td class="col-subject">{{ item.subject }}</td>
              <td class="col-module">
                <div class="module-tags-wrap">
                  <span class="module-tag" *ngFor="let mod of item.module">{{ mod }}</span>
                </div>
              </td>
              <td class="col-helpdesk">
                <span class="helpdesk-id" *ngIf="item.helpdesk_id">{{ item.helpdesk_id }}</span>
                <span class="helpdesk-empty" *ngIf="!item.helpdesk_id">—</span>
              </td>
              <td class="col-action">
                <span class="expand-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                    stroke-linejoin="round" viewBox="0 0 24 24">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </span>
              </td>
            </tr> -->

            <tr class="highlight-row"
                *ngFor="let item of highlightItems; let i = index"
                (click)="openHighlightModal(item, $event)">
              <td class="col-sno text-center" style="vertical-align: top;">{{ i + 1 }}.</td>
              <td class="col-opid" style="vertical-align: top;">{{ item.opid }}</td>
              <td class="col-change" style="vertical-align: top;">
                <span class="change-badge" [ngClass]="getChangeBadgeClass(item.changes)">
                  {{ item.changes }}
                </span>
              </td>
              <td class="col-module" style="vertical-align: top;">
                <div class="module-tags-wrap">
                  <span class="module-tag" *ngFor="let mod of item.module">{{ mod }}</span>
                </div>
              </td>
              <td class="col-subject" style="vertical-align: top;">{{ item.subject }}</td>
              <td class="col-helpdesk" style="vertical-align: top;">
                <span class="helpdesk-id" *ngIf="item.helpdesk_id">{{ item.helpdesk_id }}</span>
                <span class="helpdesk-empty" *ngIf="!item.helpdesk_id">—</span>
              </td>
              <td class="col-action" style="vertical-align: top;">
                <span class="expand-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                    stroke-linejoin="round" viewBox="0 0 24 24">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="hl-lightbox" *ngIf="lightboxOpen" (click)="closeLightbox()">
      <button class="hl-lightbox-close" (click)="closeLightbox()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" viewBox="0 0 24 24">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
      <button class="hl-lightbox-nav prev" (click)="lightboxPrev(); $event.stopPropagation()"
        *ngIf="lightboxImages.length > 1">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
          stroke-linejoin="round" viewBox="0 0 24 24">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
      <div class="hl-lightbox-img-wrap" (click)="$event.stopPropagation()">
        <img [src]="lightboxImages[lightboxIndex]" alt="Screenshot" />
        <div class="hl-lightbox-counter" *ngIf="lightboxImages.length > 1">
          {{ lightboxIndex + 1 }} / {{ lightboxImages.length }}
        </div>
      </div>
      <button class="hl-lightbox-nav next" (click)="lightboxNext(); $event.stopPropagation()"
        *ngIf="lightboxImages.length > 1">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
          stroke-linejoin="round" viewBox="0 0 24 24">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </button>
    </div>

    <!-- FAQ -->
    <div class="faq-section mt-5" *ngIf="faqItems.length > 0">
      <div class="d-flex justify-content-between align-items-baseline mb-3">
        <h2 class="fw-bold mb-0 section-title">Frequently Asked Questions</h2>
        <span class="section-link">FAQ</span>
      </div>

      <div class="faq-list">
        <div class="faq-item" *ngFor="let faq of faqItems; let i = index">
          <button class="faq-question" (click)="toggleFaq(i)">
            <span>{{ faq.question }}</span>
            <span class="faq-toggle">{{ activeFaqIndex === i ? '−' : '+' }}</span>
          </button>
          <div class="faq-answer" #answerEl>
            <p>{{ faq.answer }}</p>
            <div class="faq-media-item" *ngIf="faq._imageDocId">

              <div class="faq-img-loader" *ngIf="faq.image_loading">
                <span class="faq-spinner"></span>
                <span class="faq-img-loader-text">Loading image…</span>
              </div>

              <div class="faq-media-img-wrap" *ngIf="!faq.image_loading && faq.image_src">
                <div class="faq-media-label">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" viewBox="0 0 24 24">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5"/>
                    <polyline points="21 15 16 10 5 21"/>
                  </svg>
                  Image
                </div>
                <img
                  [src]="faq.image_src"
                  [alt]="faq.question"
                  class="faq-media-img"
                  loading="lazy"
                  (load)="refreshFaqHeight(i)"
                />
              </div>

              <div class="faq-img-error" *ngIf="!faq.image_loading && faq.image_error">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                Image could not be loaded.
              </div>
            </div>

            <div class="faq-media-item" *ngIf="faq.video_url">
              <div class="faq-media-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" viewBox="0 0 24 24">
                  <polygon points="23 7 16 12 23 17 23 7"/>
                  <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                </svg>
                Video
              </div>
              <div class="faq-media-video-wrap">
                <video class="faq-media-video" controls preload="metadata">
                  <source [src]="faq.video_url" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </main>
</div>

<!-- HIGHLIGHT DETAIL MODAL -->
<div class="hl-modal-backdrop" *ngIf="highlightModalOpen" (click)="closeHighlightModal()">
  <div class="hl-modal" (click)="$event.stopPropagation()">

    <div class="hl-modal-header">
      <div class="hl-modal-header-left">
        <span class="change-badge" [ngClass]="getChangeBadgeClass(selectedHighlight!.changes)">
          {{ selectedHighlight!.changes }}
        </span>
        <span class="hl-modal-opid">OP ID: <strong>{{ selectedHighlight!.opid }}</strong></span>
        <span class="helpdesk-id" *ngIf="selectedHighlight!.helpdesk_id">
          {{ selectedHighlight!.helpdesk_id }}
        </span>
      </div>
      <button class="hl-modal-close" (click)="closeHighlightModal()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" viewBox="0 0 24 24">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="hl-modal-body">

      <h3 class="hl-modal-subject">{{ selectedHighlight!.subject }}</h3>

      <div class="detail-description-wrap" *ngIf="selectedHighlight!.description">
        <div class="detail-description-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" viewBox="0 0 24 24">
            <line x1="8" y1="6" x2="21" y2="6"/>
            <line x1="8" y1="12" x2="21" y2="12"/>
            <line x1="8" y1="18" x2="21" y2="18"/>
            <line x1="3" y1="6" x2="3.01" y2="6"/>
            <line x1="3" y1="12" x2="3.01" y2="12"/>
            <line x1="3" y1="18" x2="3.01" y2="18"/>
          </svg>
          Description
        </div>
        <p class="detail-description-text">{{ selectedHighlight!.description }}</p>
      </div>

      <div class="faq-img-loader" *ngIf="selectedHighlight!.images_loading">
        <span class="faq-spinner"></span>
        <span class="faq-img-loader-text">Loading images…</span>
      </div>

      <div class="detail-images-wrap"
           *ngIf="selectedHighlight!.image && selectedHighlight!.image.length > 0">
        <div class="detail-images-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" viewBox="0 0 24 24">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
          </svg>
          Images
          <span class="detail-img-count">{{ selectedHighlight!.image.length }}</span>
        </div>

        <div class="modal-carousel">
          <div class="modal-carousel-track-wrap">
            <div class="modal-carousel-track"
                 [style.transform]="'translateX(-' + (carouselIndex * 100) + '%)'">
              <div class="modal-carousel-slide"
                   *ngFor="let img of selectedHighlight!.image; let idx = index">
                <img [src]="img"
                     [alt]="selectedHighlight!.subject + ' screenshot ' + (idx + 1)"
                     loading="lazy" />
              </div>
            </div>
          </div>

          <button class="modal-carousel-btn prev"
                  *ngIf="selectedHighlight!.image.length > 1"
                  (click)="carouselPrev(); $event.stopPropagation()"
                  aria-label="Previous image">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
              stroke-linejoin="round" viewBox="0 0 24 24">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <button class="modal-carousel-btn next"
                  *ngIf="selectedHighlight!.image.length > 1"
                  (click)="carouselNext(); $event.stopPropagation()"
                  aria-label="Next image">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
              stroke-linejoin="round" viewBox="0 0 24 24">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>

          <div class="modal-carousel-dots" *ngIf="selectedHighlight!.image.length > 1">
            <span class="modal-carousel-dot"
                  *ngFor="let img of selectedHighlight!.image; let idx = index"
                  [class.active]="carouselIndex === idx"
                  (click)="carouselGoTo(idx); $event.stopPropagation()">
            </span>
          </div>

          <div class="modal-carousel-counter" *ngIf="selectedHighlight!.image.length > 1">
            {{ carouselIndex + 1 }} / {{ selectedHighlight!.image.length }}
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

<!-- PDF MODAL -->
<div class="pdf-modal-backdrop" *ngIf="pdfModalOpen" (click)="closePdfModal()">
  <div class="pdf-modal" (click)="$event.stopPropagation()">

    <div class="pdf-modal-header">
      <div class="pdf-modal-title">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
        Release Document
      </div>
      <button class="pdf-modal-close" (click)="closePdfModal()" aria-label="Close PDF viewer">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" viewBox="0 0 24 24">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="pdf-modal-body">
      @if (pdfLoading) {
        <div class="faq-img-loader">
          <span class="faq-spinner"></span>
          <span class="faq-img-loader-text">Loading document…</span>
        </div>
      } @else if (pdfBase64Src) {
        <ng2-pdfjs-viewer
          [pdfSrc]="pdfBase64Src"
          [openFile]="false">
        </ng2-pdfjs-viewer>
      }
      <div class="pdf-modal-empty" *ngIf="!pdfLoading && !pdfBase64Src">
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none"
          stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
        <span>{{ pdfError ? 'Document could not be loaded' : 'No document available' }}</span>
      </div>
    </div>

  </div>
</div>

<!-- INDEX IMAGE MODAL -->
<div class="hl-modal-backdrop" *ngIf="indexModalOpen" (click)="closeIndexModal()">
  <div class="hl-modal" (click)="$event.stopPropagation()">

    <div class="hl-modal-header">
      <div class="hl-modal-header-left">
        <span class="module-tag">{{ indexModalItem?.module }}</span>
        <span class="hl-modal-opid">{{ indexModalItem?.slide }}</span>
      </div>
      <button class="hl-modal-close" (click)="closeIndexModal()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" viewBox="0 0 24 24">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="hl-modal-body">

      <div class="modal-carousel" *ngIf="indexModalItem?.images?.length">

        <div class="modal-carousel-track-wrap">
          <div class="modal-carousel-track"
               [style.transform]="'translateX(-' + (indexCarouselIdx * 100) + '%)'">
            <div class="modal-carousel-slide"
                 *ngFor="let img of indexModalItem!.images; let i = index">
              <img [src]="img"
                   [alt]="indexModalItem!.module + ' slide ' + (i + 1)"
                   loading="lazy" />
            </div>
          </div>
        </div>

        <button class="modal-carousel-btn prev"
                *ngIf="indexModalItem!.images!.length > 1"
                (click)="indexCarouselPrev(); $event.stopPropagation()"
                aria-label="Previous image">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" viewBox="0 0 24 24">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>

        <button class="modal-carousel-btn next"
                *ngIf="indexModalItem!.images!.length > 1"
                (click)="indexCarouselNext(); $event.stopPropagation()"
                aria-label="Next image">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </button>

        <div class="modal-carousel-dots" *ngIf="indexModalItem!.images!.length > 1">
          <span class="modal-carousel-dot"
                *ngFor="let img of indexModalItem!.images; let i = index"
                [class.active]="indexCarouselIdx === i"
                (click)="indexCarouselGoTo(i); $event.stopPropagation()">
          </span>
        </div>

        <div class="modal-carousel-counter" *ngIf="indexModalItem!.images!.length > 1">
          {{ indexCarouselIdx + 1 }} / {{ indexModalItem!.images!.length }}
        </div>

      </div>

      <div class="faq-img-loader" *ngIf="indexModalItem?.images_loading">
        <span class="faq-spinner"></span>
        <span class="faq-img-loader-text">Loading images…</span>
      </div>

      <!-- Empty state -->
      <div class="idx-modal-empty" *ngIf="!indexModalItem?.images_loading && !indexModalItem?.images?.length">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"
          stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" viewBox="0 0 24 24">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <circle cx="8.5" cy="8.5" r="1.5"/>
          <polyline points="21 15 16 10 5 21"/>
        </svg>
        <span>No images available</span>
      </div>

    </div>
  </div>
</div>